export enum Alignment {
  LEFT = 'L',
  RIGHT = 'R',
  CENTER = 'C'
}

export enum Category {
  HEHM = 'HEHM',
  Thermostat = 'Thermostat',
  None = 'None'
}

export enum Selection {
  SINGLE = 'S',
  MULTI = 'M'
}
